export enum PaymentStatuses {
    Informed = 'Informed',
    Confirmed = 'Confirmed',
    Processed = 'Processed',
    Rejected = 'Rejected',
    Annulled = 'Annulled',
}
